<template>
  <div>
    <div class="d-none d-md-block pa-4 pa-md-2">
      <Breadcrumbs headline="Nhân viên" :link="[{ text: 'Nhân viên', to: '/staffs' }]" />
    </div>
    <v-card class="pa-2 mx-md-2">
      <v-row no-gutters v-if="staff">
        <v-app-bar class="d-md-none mb-2 white">
          <v-btn to="/staffs" icon>
            <v-icon left>mdi-arrow-left</v-icon>
          </v-btn>
          <h3>Hồ sơ</h3>
          <v-spacer></v-spacer>
          <div class="d-flex flex-row justify-end">
            <v-btn
              depressed
              medium
              class="primary--text mr-2"
              color="blue lighten-5"
              right
              @click="cancel"
              >Hủy</v-btn
            >
            <v-btn depressed medium color="primary" @click="save">Lưu</v-btn>
          </div>
        </v-app-bar>

        <v-col :class="{ 'text-center': $vuetify.breakpoint.smAndDown }" cols="12" md="4">
          <h2 class="mb-4">{{ staff.name }}</h2>
          <user-avatar-picker
            @updated="onUploaded"
            v-if="staff"
            :type="'staff'"
            :student="staff"
            :avatar="avatar"
          />
        </v-col>

        <v-col cols="12" md="8">
          <v-card flat>
            <v-form @submit.prevent="save">
              <v-card-text>
                <v-text-field
                  v-model="staffData.name"
                  label="Nhân Viên"
                  placeholder="Nhập tên Nhân Viên"
                  required
                ></v-text-field>
                <v-text-field
                  disabled
                  v-model="staffData.code"
                  label="Mã Nhân Viên"
                  placeholder="Nhập mã Nhân Viên"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="staffData.phone"
                  label="Số điện thoại"
                  placeholder="Nhập số điện thoại"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="staffData.email"
                  label="Email"
                  placeholder="Nhập email"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn depressed small right color="error" @click="cancel">Cancel</v-btn>
                <v-btn depressed small type="submit" color="success" style="margin: 0 20px"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapActions, mapGetters } from 'vuex'
import UserAvatarPicker from '@/components/basic/picker/UserAvatarPicker'
export default {
  components: {
    UserAvatarPicker,
    Breadcrumbs
  },
  data() {
    return {
      staffData: {
        name: '',
        phone: '',
        email: '',
        username: '',
        code: ''
      }
    }
  },
  computed: {
    ...mapGetters('staff', ['staffs']),
    staff() {
      if (!this.staffs) {
        return
      }
      return this.staffs.find(s => s.id === this.$route.params.id)
    },
    avatar() {
      if (!this.staff) {
        return
      }
      return this.staff.avatar
    }
  },
  watch: {
    staff(v) {
      if (!v) {
        return
      }
      this.staffData = {
        name: v.name,
        phone: v.phone,
        email: v.email,
        username: v.code,
        code: v.code
      }
    }
  },
  methods: {
    ...mapActions('staff', ['fetchStaff', 'updateStaff']),
    async onUploaded() {
      await this.refreshData()
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    save() {
      this.updateStaff({
        id: this.staff.id,
        ...this.staffData
      })
    },
    cancel() {
      this.$router.back()
    },
    async refreshData() {
      const res = await this.fetchStaff(this.$route.params.id)
      this.staffData = {
        name: res.name,
        phone: res.phone,
        email: res.email,
        username: res.code,
        code: res.code
      }
    }
  },
  async created() {
    await this.refreshData()
  }
}
</script>
